'use strict';

angular.module('app').directive('progressBar', function($compile) {

    var link = function(scope, elem) {
        if (!scope.steps || scope.steps && scope.steps.length === 0) {
            console.warn('There is no steps to display');
        }
    }

    return {
        restrict: 'AE',
        template: 
        '<div class="step-progress-bar">'+
            '<div ng-repeat="currentStep in steps" ng-click="onSelect({ step: $index + 1 })" class="step-progress-bar__item" ng-class="{ finished: step > $index + 1, active: step === $index + 1 }">' +
                '<span class="step-progress-bar__step">{{ $index + 1 }}</span>'+
                '<span class="step-progress-bar__title full">{{ currentStep.text }}</span>' +
                '<span class="step-progress-bar__title short">{{ currentStep.shortText }}</span>' +
                '<span class="step-progress-bar__delimeter" ng-if="!$last"></span>' +
            '</div>' + 
            '<button class="total-price" ng-if="step != 1 && showPrice && totalPrice">{{ $root.setValue(totalPrice, currency) }}</button>'+
        '</div>',
        scope: {
            step: '=',
            steps: '=',
            totalPrice: '=',
            showPrice: '=',
            currency: '=',
            onSelect: '&'
        },
        link: link
    };
});